import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';
import { Answers, IQuestionModel } from '@care-portals/api-interfaces';

@Component({
  selector: 'consultation-question',
  templateUrl: './consultation-question.component.html',
  styleUrls: ['./consultation-question.component.less']
})
export class ConsultationQuestionComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() question: IQuestionModel;
  @Input() data: any;
  @Input() brand: string;
  @Input() allAnswers: any;

  @Input() answers: Answers;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      if (this.data === undefined) {
        this.data = {};
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  get validateCheck() {
    const options = this.question.answer.options;

    for (const a in options) {
      if (this.data[options[a].key]) return true;
    }
    return '';
  }
}
